import { render, staticRenderFns } from "./UnavailabilityDay.vue?vue&type=template&id=413656a6&scoped=true&"
import script from "./UnavailabilityDay.vue?vue&type=script&lang=ts&"
export * from "./UnavailabilityDay.vue?vue&type=script&lang=ts&"
import style0 from "./UnavailabilityDay.vue?vue&type=style&index=0&id=413656a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413656a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
